module.exports = __webpack_public_path__ + "img/IMG_8263.c8cf7a57.jpeg";